<template>
    <b-modal id="plan-details-modal" size="md" :title="plan?.plan?.name || 'Plan Details'" ok-only ok-variant="secondary" ok-title="Close">
        <template v-if="plan">
            <b-row class="mb-2">
                <b-col cols="4" class="font-weight-bold">Plan Name</b-col>
                <b-col>{{ plan.plan.name || '—' }}</b-col>
            </b-row>
            <b-row class="mb-2">
                <b-col cols="4" class="font-weight-bold">BIN</b-col>
                <b-col>{{ plan.plan.bin || '—' }}</b-col>
            </b-row>
            <b-row class="mb-2">
                <b-col cols="4" class="font-weight-bold">PCN</b-col>
                <b-col>{{ plan.plan.pcn || '—' }}</b-col>
            </b-row>
            <b-row class="mb-2">
                <b-col cols="4" class="font-weight-bold">Phone</b-col>
                <b-col>
                    <a v-if="plan.plan.phoneNumber" :href="'tel:' + plan.plan.phoneNumber">{{ plan.plan.phoneNumber }}</a>
                    <span v-else>—</span>
                </b-col>
            </b-row>
            <b-row v-if="plan.patientPlan.helpdeskNumber" class="mb-2">
                <b-col cols="4" class="font-weight-bold">Helpdesk</b-col>
                <b-col>
                    <a :href="'tel:' + plan.patientPlan.helpdeskNumber">{{ plan.patientPlan.helpdeskNumber }}</a>
                </b-col>
            </b-row>
            <b-row class="mb-2">
                <b-col cols="4" class="font-weight-bold">Provider Type</b-col>
                <b-col>{{ plan.plan.providerTypeDesc || '—' }}</b-col>
            </b-row>
            <b-row class="mb-2">
                <b-col cols="4" class="font-weight-bold">Group ID</b-col>
                <b-col>{{ plan.patientPlan.groupId || '—' }}</b-col>
            </b-row>
            <b-row class="mb-2">
                <b-col cols="4" class="font-weight-bold">Cardholder ID</b-col>
                <b-col>{{ plan.patientPlan.cardholderId || '—' }}</b-col>
            </b-row>
            <b-row class="mb-2">
                <b-col cols="4" class="font-weight-bold">Member ID</b-col>
                <b-col>{{ plan.patientPlan.memberId || '—' }}</b-col>
            </b-row>
            <b-row v-if="formattedAddress" class="mb-2">
                <b-col cols="4" class="font-weight-bold">Address</b-col>
                <b-col>{{ formattedAddress }}</b-col>
            </b-row>
            <b-row v-if="plan.plan.planMessage" class="mb-2">
                <b-col cols="4" class="font-weight-bold">Plan Message</b-col>
                <b-col>{{ plan.plan.planMessage }}</b-col>
            </b-row>
        </template>
    </b-modal>
</template>

<script lang="ts">
import { Component, Prop, Vue } from 'vue-property-decorator';
import { CombinedPlan } from '@/models/CombinedPlan';

@Component({ name: 'PlanDetailsModal' })
export default class PlanDetailsModal extends Vue {
    @Prop({ default: null }) plan!: CombinedPlan | null;

    get formattedAddress(): string {
        if (!this.plan?.plan) return '';
        const p = this.plan.plan;
        const parts = [p.address1, p.address2].filter(Boolean);
        const cityStateZip = [p.addressCity, p.addressState].filter(Boolean).join(', ');
        if (p.addressZip) parts.push(cityStateZip ? `${cityStateZip} ${p.addressZip}` : p.addressZip);
        else if (cityStateZip) parts.push(cityStateZip);
        return parts.join(', ');
    }
}
</script>
